import { Paginated } from '../../common/pagination.js';
import { TicketView } from '../../help.js';
import { AgentReplyInput, TicketQueueQuery } from './schemas.js';
export const adminSupportRoutes = {
    tickets: {
        method: 'GET',
        path: '/admin/tickets',
        query: TicketQueueQuery,
        response: Paginated(TicketView),
    },
    ticketReply: {
        method: 'POST',
        path: '/admin/tickets/:ticketId/reply',
        body: AgentReplyInput,
        response: TicketView,
    },
};
//# sourceMappingURL=routes.js.map